import { useFlags } from "launchdarkly-react-client-sdk";
import { useUser } from "src/contexts/user-context";

export const useNestedFilteringFlag = () => {
  const { workspace } = useUser();
  const { queryBuilderNestedFiltering, agentsAudienceSkillV3 } = useFlags();
  return (
    queryBuilderNestedFiltering ||
    (agentsAudienceSkillV3 && workspace?.personalization?.agents?.tosAccepted)
  );
};
